<div class="modal active importModal">
  <div class="modal__container modal__container--md">
      <div class="fields">
          <h2>Import {{ entity }}</h2>
          <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
          <label class="importModal__desc">Please choose the file type you want to import:</label>
          <div class="fields__container" *ngIf="!entity?.includes('RFI-Transmitter') && entity != 'Receivers'; else grit">
            <div class="fields__container__button" *ngFor="let format of this.formatsToDisplay">
              <div *ngIf="entity != 'Procedures' && entity != 'Route Segments' && entity != 'NavAids' && entity !='Vertex' && entity != 'RVT/KMZ'" (click)="upload.click()">
                <input [accept]="format.fileExtension" id="import" hidden type="file" #upload (change)="uploadFile($event.target.files, format.format)"/>
                <label>{{ format.format }}</label>
              </div>
              <div *ngIf="this.entity == 'Procedures' && format.format !='NM AIXM 5.1' && format.format != 'CSV' && format.format != 'Import and Create Procedure from Route Segments - CSV'" (click)="uploadProc.click()">
                <input [accept]="format.fileExtension" id="procedureFile" hidden type="file" #uploadProc (change)="uploadFile($event.target.files, format.format)"/>
                <label>{{ format.format }}</label>
              </div>
              <div *ngIf="this.entity == 'Procedures' && format.format == 'NM AIXM 5.1'" (click)="uploadProcedureNMAIXM51()">
                <label>{{ format.format }}</label>
              </div>
              <div *ngIf="this.entity == 'Procedures' && format.format == 'CSV'" (click)="uploadProcedureCSV()">
                <label>{{ format.format }}</label>
              </div>
              <div *ngIf="this.entity == 'Procedures' && format.format == 'Import and Create Procedure from Route Segments - CSV'" (click)="uploadProcedureFromRouteSegmentCSV()">
                <label>{{ format.format }}</label>
              </div>
              <div *ngIf="this.entity == 'Route Segments' && format.format == 'CSV'" (click)="uploadRouteSegmentsCSV()">
                <label>{{ format.format }}</label>
              </div>
              <div *ngIf="this.entity == 'Route Segments' && format.format == 'EAD AIXM 4.5'" (click)="uploadRouteSegmentsXML(false)">
                <label>{{ format.format }}</label>
              </div>
              <div *ngIf="this.entity == 'Route Segments' && format.format == 'EAD AIXM 5.1'" (click)="uploadRouteSegmentsXML(true)">
                <label>{{ format.format }}</label>
              </div>
              <div *ngIf="this.entity == 'NavAids' && format.format == 'CSV'" (click)="uploadNavaidsCSV()">
                <label>{{ format.format }}</label>
              </div>
              <div *ngIf="this.entity == 'NavAids' && format.format != 'CSV'" (click)="upload.click()">
                <input [accept]="format.fileExtension" id="import" hidden type="file" #upload (change)="uploadFile($event.target.files, format.format)"/>
                <label>{{ format.format }}</label>
              </div>
              <div *ngIf="this.entity == 'Vertex' && format.format == 'CSV'" (click)="uploadVertexCSV()">
                <label>{{ format.format }}</label>
              </div>
              <div *ngIf="this.entity == 'Vertex' && format.format != 'CSV'" (click)="upload.click()">
                <input [accept]="format.fileExtension" id="import" hidden type="file" #upload (change)="uploadFile($event.target.files, format.format)"/>
                <label>{{ format.format }}</label>
              </div>

			        <div *ngIf="this.entity == 'RVT/KMZ'"  (click)="uploadFile($event.target.files, format.format)">
                <label>{{ format.format }}</label>
              </div>
            </div>
          </div>

        <ng-template #grit>
          <div class="fields__container">
            <div class="fields__block" style="background-color: transparent">
              <div class="fields__block__section">
                <div class="dropdown-fields">
                  <div>
                    <label> Import using group:</label>
                      <select id="groupSelect">
                        <option *ngFor="let group of gritUserService.groupsPaths" [value]="group">{{ group }}</option>
                      </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__container__button" *ngFor="let format of this.formatsToDisplay">
              <div *ngIf="format == 'JSON'" (click)="uploadJSON.click()">
                <input id="uploadJSON" hidden type="file" accept=".json" #uploadJSON (change)="importJson($event.target.files)"/>
                <label>{{ format }}</label>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
  </div>
</div>

